import React from 'react';
import { bool } from 'prop-types';
import { FormattedMessage, intlShape } from '../../util/reactIntl';
import { convertMoneyToNumber, formatAmountOnly } from '../../util/currency';
import { CurrencySymbol } from '../../components';
import { LINE_ITEM_NIGHT, LINE_ITEM_DAY, propTypes, LINE_ITEM_HOUR } from '../../util/types';

import css from './OrderBreakdown.module.css';

const LineItemBasePriceMaybe = props => {
  const { lineItems, code, intl, isFixedModel, isNegotiatedModel } = props;
  const isNightly = code === LINE_ITEM_NIGHT;
  const isDaily = code === LINE_ITEM_DAY;
  const isHourly = code === LINE_ITEM_HOUR;
  // A fixed-model service's line item quantity is always 1 (its price is
  // the flat total for the whole session, not a per-hour rate — see
  // server/api-util/dealPricing.js), so "x {quantity}h" would misreport a
  // 3-hour session as "x 1h". Use a duration-free label instead. A negotiated
  // quote's base line item is the agreed Labour/Service amount only, so it
  // gets its own duration-free label too.
  const translationKey = isNightly
    ? 'OrderBreakdown.baseUnitNight'
    : isDaily
    ? 'OrderBreakdown.baseUnitDay'
    : isHourly
    ? isNegotiatedModel
      ? 'OrderBreakdown.baseUnitHourNegotiated'
      : isFixedModel
      ? 'OrderBreakdown.baseUnitHourFixed'
      : 'OrderBreakdown.baseUnitHour'
    : 'OrderBreakdown.baseUnitQuantity';

  // Find correct line-item for given code prop.
  // It should be one of the following: 'line-item/night, 'line-item/day', 'line-item/hour', or 'line-item/item'
  // These are defined in '../../util/types';
  const unitPurchase = lineItems.find(item => item.code === code && !item.reversal);

  const quantity = unitPurchase && unitPurchase.quantity ? unitPurchase.quantity?.d?.toString() : null;
  const unitPriceAmount = unitPurchase ? convertMoneyToNumber(unitPurchase.unitPrice) : null;
  const unitPrice = unitPriceAmount ? formatAmountOnly(intl, unitPriceAmount, 2) : null;
  const totalAmount = unitPurchase ? convertMoneyToNumber(unitPurchase.lineTotal) : null;
  const total = totalAmount ? formatAmountOnly(intl, totalAmount, 2) : null;

  return quantity && total ? (
    <div className={css.lineItem}>
      <span className={css.itemLabel}>
        <FormattedMessage id={translationKey} values={{ unitPrice, quantity }} />
      </span>
      <span className={css.itemValue}>
        <CurrencySymbol size={16} />
        <span>&nbsp;{total}</span>
      </span>
    </div>
  ) : null;
};

LineItemBasePriceMaybe.propTypes = {
  lineItems: propTypes.lineItems.isRequired,
  code: propTypes.lineItemUnitType.isRequired,
  intl: intlShape.isRequired,
  isFixedModel: bool,
  isNegotiatedModel: bool,
};

export default LineItemBasePriceMaybe;
